import React from "react";
import Section from "../../../layout/Section";
import TextEditorField from "../../../common/editor/TextEditorField";

interface AreaInfoSectionProps {
  flaechenbeschreibung: string;
  setFlaechenbeschreibung: (value: string) => void;
  isEditMode: boolean;
  canEdit: boolean;
}

const AreaInfoSection: React.FC<AreaInfoSectionProps> = ({
  flaechenbeschreibung,
  setFlaechenbeschreibung,
  isEditMode,
  canEdit,
}) => {
  return (
    <Section
      title="Zusätzliche Informationen"
      noInnerPadding={true}
      sx={{ overflow: "hidden" }}
    >
      <TextEditorField
        value={flaechenbeschreibung}
        onChange={setFlaechenbeschreibung}
        placeholder="Beschreibung der Fläche, Eigentümer, Nutzungsrechte, etc. (Rich Text-Format unterstützt)"
        label=""
        readOnly={!isEditMode || !canEdit}
        labelBackgroundColor="white"
        minHeight="180px"
        noBorder
      />
    </Section>
  );
};

export default AreaInfoSection;
